import React from 'react'

import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx'
import withStyles from '@material-ui/core/styles/withStyles'
import MeetingRoom from '@material-ui/icons/MeetingRoom'
import PermContactCalendar from '@material-ui/icons/PermContactCalendar'
import CalendarToday from '@material-ui/icons/CalendarToday'

import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import InfoArea from 'components/InfoArea/InfoArea.jsx'

const SessionNotes = ({ classes }) => (
    <div className={classes.section}>
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
                <h2 className={classes.title}>Scheduling and Calendars</h2>
                <h5 className={classes.description}>
          No more physical calendars! With those, you have to do everything
          yourself. We can do so much for you.
                </h5>
            </GridItem>
        </GridContainer>
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Virtual Calendar"
                        description="Appointment and meeting reminders are all automatic with Resilient Vitality. We can keep an up-to-date calendar automatically for you."
                        icon={CalendarToday}
                        iconColor="warning"
                        vertical
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Meet With Coworkers"
                        description="Need to schedule a meeting? All you need to do is tell us who to invite and we'll find a time that works for us all."
                        icon={MeetingRoom}
                        iconColor="success"
                        vertical
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Patient Scheduling"
                        description="We can send appointment and scheduling reminders to your patients automatically through our app. Beyond that, we can tell patients times you are free to schedule their next appointment."
                        icon={PermContactCalendar}
                        iconColor="info"
                        vertical
                    />
                </GridItem>
            </GridContainer>
        </div>
    </div>
)

export default withStyles(productStyle)(SessionNotes)



// WEBPACK FOOTER //
// ./src/views/Features/PracticeManagement/Sections/Scheduling.jsx